import type { OoFormRouteContext } from '../types';
import { OoProductSelector } from './OoProductSelector';

interface CaseProductPageProps {
  routeContext: OoFormRouteContext;
}

export function CaseProductPage({ routeContext }: CaseProductPageProps) {
  return <OoProductSelector routeContext={routeContext} />;
}
